<template>
	<div class="system">
		<layout width="200px">
			<template v-slot:left>
				<publicMenu :list="list" iconUrl="list"></publicMenu>
			</template>
			<template v-slot:right>
				<router-view></router-view>
			</template>
		</layout>
	</div>
</template>

<script>
	import layout from "../../components/layout.vue"
	import publicMenu from '../../components/publicMenu.vue'
	export default{
		data(){
			return{
				list: []
			}
		},
		components: {
			layout,
			publicMenu,
		},
		methods: {
			getAll() {
				var a = JSON.parse(localStorage.getItem("cd"))
				
				a.forEach(val => {
					if (val.meta.title == '消息') {
						var b = val.children
						console.log(b)
						this.list = b
						console.log(this.list)
					}
				
				})
				return
				this.$http.get(
					`/api/api/findMenusByRoleIdAndPath?path=${this.$route.matched[1].path}&roleId=${sessionStorage.roleId}`).then(res => {
					this.list = res.data.data;
					this.$router.push(this.list[0].bdMenus[0].path);
				})
			}
		},
		mounted() {
			this.getAll();
		}
	}
</script>

<style scoped="scoped">
	
</style>
